import css from 'styled-jsx/css';

export default css`
  .Loading {
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;
